import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a drawer with automatic scroll reset.
 *
 * @extends {DialogComponent}
 */
class DrawerComponent extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();
    this.querySelector('drawer-button')?.addEventListener('click', this.open.bind(this));
    this.#resetScrollPosition();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Reset scroll position for all scrollable elements within the drawer
   */
  #resetScrollPosition() {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      // Reset scroll on drawer-items-component
      const drawerItemsComponent = this.querySelector('drawer-items-component');
      if (drawerItemsComponent instanceof HTMLElement) {
        drawerItemsComponent.scrollTop = 0;
      }

      // Reset scroll on scroll-hint elements
      const scrollHintElements = this.querySelectorAll('scroll-hint');
      scrollHintElements.forEach(element => {
        if (element instanceof HTMLElement) {
          element.scrollTop = 0;
        }
      });

      // Reset scroll on .drawer__content
      const drawerContent = this.querySelector('.drawer__content');
      if (drawerContent instanceof HTMLElement) {
        drawerContent.scrollTop = 0;
      }

      // Reset scroll on .drawer__items
      const drawerItems = this.querySelector('.drawer__items');
      if (drawerItems instanceof HTMLElement) {
        drawerItems.scrollTop = 0;
      }

      // Reset scroll on dialog element itself
      const dialog = this.querySelector('dialog');
      if (dialog instanceof HTMLElement) {
        dialog.scrollTop = 0;
      }
    });
  }

  open() {
    this.showDialog();
    // Reset scroll after dialog is shown
    this.#resetScrollPosition();
  }

  /**
   * @param {Event} event
   */
  close(event) {
    event.preventDefault();
    this.closeDialog();
  }
}

if (!customElements.get('drawer-component')) {
  customElements.define('drawer-component', DrawerComponent);
}
